import PlpTopBanner from './PlpTopBanner';

export default PlpTopBanner;
